import { setTitle } from "@store/title-store";
import { ErrorIndicator, Loader } from "@ui/indicators";

import NewsItems from "@components/news-components";
import { useNewsQuery } from "@lib/news";
import { useLocation } from "react-router-dom";
import { useEffect, FC } from "react";

const itemsPerPage = 16;

const Practice: FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    const title = [
      { title: "Главная", href: "/" },
      { title: "Новости", href: "/news/help" },
      { title: "Судебная практика", href: pathname },
    ];

    setTitle(title);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { data, isLoading, error, hasNextPage, fetchNextPage } = useNewsQuery({
    limit: itemsPerPage,
    type: "PRACTICES",
  });

  return (
    <>
      {error ? (
        <ErrorIndicator />
      ) : isLoading ? (
        <Loader />
      ) : (
        data?.pages.map((page) => (
          <NewsItems items={page.rows} path="practices" />
        ))
      )}
      {hasNextPage && (
        <button className="pagination-button" onClick={() => fetchNextPage()}>
          Показать еще
        </button>
      )}
    </>
  );
};

export default Practice;
